export const app_version = "2.4.71";
